import * as _ from 'lodash';
import { ISchool } from '../../../ng2/shared/typings/interfaces/school.interface';
import { AttendanceConfigService } from './sdc-configs/attendance-config.service';
import { CreditGapsConfigService } from './sdc-configs/credit-gaps-config.service';
import { DefaultSdcConfigService } from './sdc-configs/default-sdc-config.service';
import { GradPlanningConfigService } from './sdc-configs/grad-planning-config.service';
import { MarkingPeriodConfigService } from './sdc-configs/marking-period-config.service';
import { NextTermPlanningConfigService } from './sdc-configs/next-term-planning-config.service';
import { PendingCourseGapPlanTableConfigService } from './sdc-configs/pending-course-gap-plan-table-config.service';
import { RegentsPlanningConfigService } from './sdc-configs/regents-planning-config.service';
import { RegentsPrepConfigService } from './sdc-configs/regents-prep-config.service';
import { SdcStateServiceBaseModel } from './sdc-state-basemodel';
import { sdcStateConfigConstant } from './sdc-state-config.constant';
import { ISdcActivities, ISdcActivity, ISdcConfig, TValidSdcStates } from './sdc-state.typings';

export class SdcStateService implements ISdcActivities {
  static $inject: string[] = [
    'AttendanceConfigService',
    'CreditGapsConfigService',
    'DefaultSdcConfigService',
    'GradPlanningConfigService',
    'MarkingPeriodConfigService',
    'PendingCourseGapPlanTableConfigService',
    'RegentsPlanningConfigService',
    'RegentsPrepConfigService',
    'NextTermPlanningConfigService',
  ];

  constructor(
    private AttendanceConfigService: AttendanceConfigService,
    private CreditGapsConfigService: CreditGapsConfigService,
    private DefaultSdcConfigService: DefaultSdcConfigService,
    private GradPlanningConfigService: GradPlanningConfigService,
    private MarkingPeriodConfigService: MarkingPeriodConfigService,
    private PendingCourseGapPlanTableConfigService: PendingCourseGapPlanTableConfigService,
    private RegentsPlanningConfigService: RegentsPlanningConfigService,
    private RegentsPrepConfigService: RegentsPrepConfigService,
    private NextTermPlanningConfigService: NextTermPlanningConfigService,
  ) {}

  public determineSdcActivityFromState(state: TValidSdcStates): ISdcActivity {
    let stateConfig = null;
    _.forEach(sdcStateConfigConstant, (config: ISdcConfig, configKey: string) => {
      if (config.state === state) {
        stateConfig = configKey;
        return;
      }
    });
    const activity: ISdcActivity = stateConfig && this[stateConfig];
    return activity;
  }

  public init(currentSchool: ISchool) {
    // Initialize any state configs that depend on currentSchool here
    const configsRequiringSchool = ['GRAD_PLANNING', 'CREDIT_GAPS', 'REGENTS_PLANNING', 'MARKING_PERIOD'];

    configsRequiringSchool.forEach((configName: string) => {
      const activity: SdcStateServiceBaseModel = this[configName];
      activity.init(currentSchool);
    });
  }

  get ATTENDANCE(): AttendanceConfigService {
    return this.AttendanceConfigService;
  }

  get CREDIT_GAPS(): CreditGapsConfigService {
    return this.CreditGapsConfigService;
  }

  get DEFAULT_SDC(): DefaultSdcConfigService {
    return this.DefaultSdcConfigService;
  }

  get GRAD_PLANNING(): GradPlanningConfigService {
    return this.GradPlanningConfigService;
  }

  get MARKING_PERIOD(): MarkingPeriodConfigService {
    return this.MarkingPeriodConfigService;
  }

  get PENDING_COURSE_GAP_PLAN_TABLE(): PendingCourseGapPlanTableConfigService {
    return this.PendingCourseGapPlanTableConfigService;
  }

  get NEXT_TERM_PLANNING_TABLE(): NextTermPlanningConfigService {
    return this.NextTermPlanningConfigService;
  }

  get REGENTS_PLANNING(): RegentsPlanningConfigService {
    return this.RegentsPlanningConfigService;
  }

  get REGENTS_PREP(): RegentsPrepConfigService {
    return this.RegentsPrepConfigService;
  }
}
